@if (_line != null) {
    <div class="line"
        [style]="{top: _line.y1 + 'px', left: _line.x1 + 'px', width: length + 'px', transform: 'rotate(' + angle + 'deg)'}">
    </div>
}
